import store from '@/store/index'
import clientLogger from '@/plugins/logger/core'
import Config from '@/config'

import { DEFAULT_DATA_PARAMS, TRACKING_EVENTS } from '@/constants/tracking'

const setTrackingParams = (params) => {
  try {
    return store.dispatch('userTracking/updateParameters', params)
  } catch (error) {
    clientLogger.warn(
      error,
      { data: JSON.stringify(params), method: 'setTrackingParams' },
      { category: 'tracking' }
    )

    return {}
  }
}

const getTrackingData = (eventName) => {
  try {
    const eventConfig = Object.values(TRACKING_EVENTS).find(
      (e) => e.EVENT_NAME === eventName
    )
    // default data
    const defaultData = getTrackingParams(DEFAULT_DATA_PARAMS) || {}
    const appVersion = Config.env + '.' + Config.releaseVersion
    // event data
    const eventParams = eventConfig && eventConfig.EVENT_DATA_PARAMS
    const eventData = eventParams ? getTrackingParams(eventParams) : {}
    return { ...defaultData, ...eventData, checkout_ui_version: appVersion }
  } catch (error) {
    clientLogger.warn(
      error,
      { eventName, method: 'getTrackingData' },
      { category: 'tracking' }
    )
    return {}
  }
}

const getTrackingParams = (keys) => {
  try {
    return store.getters['userTracking/getParameters'](keys)
  } catch (error) {
    clientLogger.warn(
      error,
      { data: JSON.stringify(keys), method: 'getTrackingParams' },
      { category: 'tracking' }
    )

    return {}
  }
}

export default { getTrackingParams, setTrackingParams, getTrackingData }
